
import React, { useState } from 'react';
import { motion } from 'framer-motion';


import barsIcon from './images/images-rentApp/bars-icon.svg'
import gridIcon from './images/images-rentApp/gridIcon.svg'
import listIcon from './images/images-rentApp/list-icon.svg'
import filterIcon from './images/images-rentApp/filter-icon.svg'
import searchIcon from './images/images-rentApp/search-icon.svg'
import downArrow from './images/images-rentApp/downArrow.svg'
import checkIcon from './images/images-rentApp/check-icon.svg'
import plusIcon from './images/images-rentApp/plus-icon.svg'

const  FilterPopup = React.forwardRef ((props, ref) => {
       
        function PropPill (props){

            const [Icon, setIcon] = useState(plusIcon)
            const [BgColor, setBgColor] = useState('#ffffff')
            const [TextColor, setTextColor] = useState('#343434')

            const handePillHover =()=>{

                setBgColor('#fefefe')
            }
            const handePillClick =()=>{
                if (Icon === plusIcon) {
                    setBgColor('#8A17E9');
                    setIcon(checkIcon);
                    setTextColor('#ffffff');
                    } else {
                    setIcon(plusIcon);
                    setBgColor('#ffffff');
                    setTextColor('#343434');
                    }
                }

            return(                

                <div className='propPill' style={{'background-color': BgColor, color: TextColor}} onMouseEnter={(()=> handePillHover)} onClick={(()=> handePillClick())}><img src={Icon}/>{props.label}</div>

            )
                
            
        }

        const variants = {
            visible: { opacity: 1, transition: { duration: 0.2 } },
            hidden: { opacity: 0, transition: { duration: 0.3 } },
            };

        return( 

            <motion.div className='filterMain' id='filterMainBG' ref={ref} initial="hidden" animate={'visible'} variants={variants}>
                <div className='filterContainer' id='filterMainTag' >
                    <button class="closeButton" onClick={(() => props.setFilterPop(false))}>&times;</button>

                    <div className='popUpHeader'>Filters</div>
                    <h3 style={{width: '100%'}}>Property type</h3>
                    <div className='pillsContainer'>

                            <PropPill label='WG'/>
                            <PropPill label='1-Zimmer Wohnung'/>
                            <PropPill label='Wohnung'/>
                            <PropPill label='Haus'/>
                        </div>
                    <h3 style={{width: '100%'}}>Price range</h3>

                        <div className='priceRangeContainer'>
                            <div className='rangeSlider'>
                                <div style={{'display': 'flex', 'flex-direction': 'column', gap: '5px', 'align-items': 'center'}}>
                                        <div className='smallPill'>290€</div>
                                        <div className='sliderHande'/>
                                    </div>
                                    <div style={{'display': 'flex', 'justify-content': 'center', height: '5px'}}>
                                        <div className='sliderLine'/>
                                        <div className='sliderLine' style={{position: 'absolute', width: '100%', 'background-color': '#dedede', 'z-index': '0'}}/>
                                    </div>
                                    <div style={{'display': 'flex', 'flex-direction': 'column', gap: '5px', 'align-items': 'center'}}>
                                        <div className='smallPill'>455€</div>
                                        <div className='sliderHande'/>
                                    </div>                    
                                </div>

                                <div className='rangeSlider' style={{'justify-content': 'space-between'}}>
                                    <div className='pricePill'>
                                            <input placeholder='0'type="number"  min="0"/>
                                            <span>| €</span>
                                        </div>  
                                    <div className='pricePill'>
                                        <input placeholder='9999' type="number"   min="0" />
                                        <span>| €</span>
                                    </div>
                                </div>

                        </div>

                    <h3 style={{width: '100%'}}>Amenities</h3>
                        <div className='smallItemsContainer'>
                            <div className='checkBox'><input type="checkbox" id="Furnished" name="Furnished" />Furnished</div>
                            <div className='checkBox'><input type="checkbox" id="parking" name="parking" />Parking</div>
                            <div className='checkBox'><input type="checkbox"/>Equipped Kitchen</div>
                            <div className='checkBox'><input type="checkbox"/>Garden</div>
                            <div className='checkBox'><input type="checkbox"/>Air conditioner</div>
                        </div>

                    <h3 style={{width: '100%'}}>Duration</h3>
                    <div className='smallItemsContainer'>
                            <div className='checkBox'><input type="checkbox" id="Furnished" name="Furnished" />Long Term</div>
                            <div className='checkBox'><input type="checkbox" id="parking" name="parking" />Short Term</div>

                        </div>
                    <div className='popUpFooter'>
                        <div style={{'margin-left': '13px'}}>Clear all</div>
                        <div className='myButton' style={{'border-radius': '11px'}}>Show results</div>
                        
                        </div>
                </div>
            </motion.div>
        
        )
        
    })

    export default FilterPopup;

